import { render, staticRenderFns } from "./CardLampiranSIKSPK.vue?vue&type=template&id=1d993bb0&scoped=true"
import script from "./CardLampiranSIKSPK.vue?vue&type=script&lang=js"
export * from "./CardLampiranSIKSPK.vue?vue&type=script&lang=js"
import style0 from "./CardLampiranSIKSPK.vue?vue&type=style&index=0&id=1d993bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d993bb0",
  null
  
)

export default component.exports